import { Dispatch } from "redux";
import { setPolicyComponents, setPolicyComponentsLoading } from "@redux/actions/policy-components-actions";
import { getDeployedPolicyComponentsRequest } from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { PolicyComponentConfiguration } from "@idw-types/data/policy-component-configuration/policy-component-configuration";

export const getPolicyComponentsReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<PolicyComponentConfiguration>> => {
    dispatch(setPolicyComponentsLoading(true));
    const { data, error } = await getDeployedPolicyComponentsRequest();
    if (data?.deployedPolicyComponents) {
       
        dispatch(setPolicyComponents(data.deployedPolicyComponents));
        return data.deployedPolicyComponents;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getPolicyComponents.error.title,
                resources.requests.getPolicyComponents.error.message
            );
        }
        dispatch(setPolicyComponentsLoading(false));
        return null;
    }
};